<template>
  <div class="home_doctor">
    <div class="row justify-content-md-center">
      <div class="col-md-12">
        <contractual-reporting></contractual-reporting>
      </div>
      <!--
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-6">
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
  import ContractualReporting from './components/ContractualReporting.vue'

  export default {
    data () {
      return {
        //
      }
    },
    components: {
      ContractualReporting
    },
    methods: {
    },
    beforeMount () {
      //
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ContractualReporting/ContractualReporting.vue?4f8f1fe0